export default "__VITE_ASSET__I3Rw5Ed0__"